'use client'

import { useTranslations } from 'next-intl'
import { FreeTrialBanner as FreeTrialBannerComponent } from './free-trial-banner'

export function FreeTrialBanner() {
  const t = useTranslations('components.free_trial_banner')

  return (
    <FreeTrialBannerComponent
      title={t('title')}
      subTitle={t('sub_title_2')}
      cta={t('cta')}
      cancelText={t('cancel')}
      countdownLabels={{
        tryFreeToday: t('try_free_today'),
        hours: t('hours'),
        mins: t('mins'),
        secs: t('secs'),
      }}
    />
  )
}
